import { ActivatedRoute } from '@angular/router';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Community } from '@models/communities/community.model';
import { Component } from '@angular/core';
import { Corporation } from '@models/corporations/corporation.model';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Inject } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { OnInit } from '@angular/core';
import { StepComponent } from '../../abstract/step.component';
import { Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { sortBy } from 'lodash';

@Component({
  selector: 'app-initial-data-form',
  templateUrl: './initial-data-form.component.html',
  styleUrls: ['../../../mig-form.component.scss'],
})
export class InitialDataFormComponent extends StepComponent implements OnInit {
  constructor(
    builder: FormBuilder,
    @Inject('MigFormService')
    service: ModelService<MigForm>,
    api: CommonVerbsApiService,
    private route: ActivatedRoute
  ) {
    super(builder, service, api);
  }

  formData: FormGroup = this.builder.group({
    name: [null, [Validators.required]],
    email: [
      null,
      [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ],
    ],
    community: [null, [Validators.required]],
  });
  submit = false;
  benchmarkCorpId = environment.benchmarkCorpId;
  created = false;

  //Select options
  communities: Community[];

  override ngOnInit(): void {
    super.ngOnInit();
    this.fetchCommunities();
    this.service.model$.subscribe(model => {
      this.patch(model);
    });
  }

  private patch(model: MigForm | null) {
    if (model) {
      this.formData.patchValue({
        name: model.name,
        email: model.email,
        community: model.community,
      });
      this.created = model.user !== undefined;
    }
  }

  get form() {
    return this.formData.controls;
  }

  fetchCommunities() {
    const subscribe = this.api
      .get<Corporation>(
        `corporation/by-id/${
          this.route.snapshot.queryParams.mode === 'test'
            ? environment.migFormTestCorporationId
            : this.benchmarkCorpId
        }`,
        {},
        ['communities']
      )
      .subscribe(data => {
        this.communities = sortBy(data.communities, c => c.name);
      });
    this.unsubscribe.push(subscribe);
  }

  ngSubmit() {
    this.submit = true;
    this.formData.markAsTouched();
    if (this.formData.invalid) {
      return;
    } else {
      const model = { ...this.service.model, ...this.formData.getRawValue() };
      this.service.set(model);
      this.nextStep.emit();
    }
  }
}
